const styles = (theme) => {
  // spacing uyumluluk (mui v3/v4/v5)
  const sp = (n) =>
    typeof theme.spacing === 'function'
      ? theme.spacing(n)
      : ((theme.spacing && theme.spacing.unit) ? theme.spacing.unit * n : n * 8);

  return {
    /* ---- Menü ve tipografi ---- */
    menuList: {
      backgroundColor: 'rgba(255, 255, 255, 0.96)',
      width: '100%',
      padding: 0,
      [theme.breakpoints.up('md')]: {
        borderRadius: 0,
        overflow: 'visible',
      },
    },
    menuCardDesktop: {},
    menuItem: {
      display: 'flex',
      alignItems: 'stretch',
      fontSize: 14,
      fontWeight: 500,
      fontFamily: 'Arial, sans-serif',
      color: theme.palette.common.black,
      '&:hover': { backgroundColor: 'rgba(80, 227, 194, 0.1)' },
    },
    selected: {
      backgroundColor: '#50e3c2 !important',
      '& $primary, & $icon': { color: theme.palette.common.white },
    },
    primary: {
      color: theme.palette.common.black,
      fontSize: 14,
      fontWeight: 500,
      fontFamily: 'Arial, sans-serif',
      lineHeight: 1.2,
      wordBreak: 'break-word',
    },
    icon: {
      fontSize: 20,
      color: theme.palette.common.black,
      marginRight: 8,
      minWidth: 40,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },

    /* ---- Sayfa iskeleti ---- */
    dashboardRoot: {
    display: 'flex',
    flexDirection: 'column',
    },

    content: {
      margin: '0 auto',
      width: '100%',
      maxWidth: 1240,
      padding: sp(3),        // 24px
      overflowX: 'hidden',
    },

    /* ==== Yeni: Masaüstü iki kolonlu flex düzen ==== */
    desktopWrap: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: sp(6),            // 24px
    },
    sidebarColumn: {
      width: 232,
      flex: '0 0 232px',
      position: 'sticky',
      top: sp(0),
      alignSelf: 'flex-start',
      marginRight: sp(1),
      zIndex: 1,
    },
    mainColumn: {
      flex: '1 1 0%',
      minWidth: 0,           // overflow kırılmasın
      paddingLeft: sp(1),
    },

    /* Mobil grid (mevcut kod için) */
    gridWrap: {
      [theme.breakpoints.up('md')]: { alignItems: 'flex-start' },
    },

    mainCell: {
      [theme.breakpoints.up('md')]: { paddingTop: 0 },
    },

    mainInner: {
      [theme.breakpoints.up('md')]: {
        maxWidth: 1100,
        minWidth: 800,
        margin: '0 auto',
        paddingTop: 0,
        '& > *:first-child': { marginTop: 0, paddingTop: 0 },
        '& .MuiPaper-root:first-child, & .MuiCard-root:first-child': {
          marginTop: 0,
          paddingTop: 0,
        },
      },
      [theme.breakpoints.down('sm')]: {
        maxWidth: '100%',
        margin: '8px 0 24px',
      },
    },

    /* ---- Mobil FAB + Drawer ---- */
    fabMenu: {
      position: 'fixed',
      top: 12,
      left: 12,
      zIndex: 1301,
      display: 'none',
      boxShadow: '0 6px 16px rgba(0,0,0,0.2)',
      [theme.breakpoints.down('sm')]: { display: 'flex' },
    },
    drawerPaper: {
      width: '82vw',
      maxWidth: 340,
      borderTopRightRadius: 12,
      borderBottomRightRadius: 12,
      boxShadow: '0 12px 32px rgba(0,0,0,0.28)',
    },
    drawerHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: '8px 8px 0 8px',
    },

    /* ---- Küçük ekran tipografi/ikon ---- */
    '@media (max-width: 767.98px)': {
      menuItem: { fontSize: 13, padding: '10px 12px' },
      primary: { fontSize: 13 },
      icon: { fontSize: 18, marginRight: 6, minWidth: 36 },
    },
  };
};

export default styles;
